import React from "react";
import { QueryClientProvider, QueryClient } from "react-query";
import { Helmet } from "react-helmet";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useUi } from "@jelly/lesson";
import { JellyProvider } from "@src/components/providers/JellyProvider";
import { ConfigProvider, useConfig } from "@src/components/providers/ConfigProvider";
import { IntlProvider } from "@src/components/providers/IntlProvider";

import appConfig from "appConfig";

import "@src/assets/styles/index.scss";
import { ContentsPage } from "@src/pages/contents/Contents";

const LessonPage = React.lazy(() => import("../pages/lesson/Lesson"));
const LessonPdfPage = React.lazy(() => import("../pages/lesson/LessonPdf"));

const queryClient = new QueryClient();

const App: React.FC = () => {
  /* eslint-disable no-console */
  console.log("BUILD_METADATA", BUILD_METADATA);
  console.log("DEPLOYMENT_ENV", appConfig.DEPLOYMENT_ENV);

  return (
    <ConfigProvider>
      <JellyProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={appConfig.BASE_PATH ?? ""}>
            <Helmet defaultTitle={"Spatial Audio"} titleTemplate={`%s - ${"Spatial Audio"}`} />
            {/*<AudioPermission />*/}
            <AppContent />
          </BrowserRouter>
        </QueryClientProvider>
      </JellyProvider>
    </ConfigProvider>
  );
};

const AppContent: React.FC = () => {
  const config = useConfig();

  return (
    <IntlProvider locale={config.lang}>
      <React.Suspense fallback={<Fallback />}>
        <Routes>
          <Route path="/contents" element={<ContentsPage />} />
          <Route path="/course/:courseId/:lessonId/pdf" element={<LessonPdfPage />} />
          <Route path="/course/:courseId/:lessonId" element={<LessonPage />} />
          <Route path="/" element={<Navigate to="/contents" />} />
        </Routes>
      </React.Suspense>
    </IntlProvider>
  );
};

const Fallback = (): JSX.Element => {
  const { Spinner } = useUi();

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <Spinner />
    </div>
  );
};

export default App;
